import React from "react";

const PeakDates = (props) => {
  const blackoutDates = props.blackoutDates;

  return blackoutDates.map((pair) => {
    return (
      <tr>
        <td className="tableCell">{pair.start}</td>
        <td className="tableCell">{pair.end}</td>
      </tr>
    );
  });
};

export default PeakDates;
